<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>
		<Content class="app-content__main">
			<TableFuncs>
				<Button type="primary" icon="ios-add-circle-outline" @click="addShow">新增APP应用</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="guanli">
					<Button type="success" size="small" style="margin-right: 15px"
						:to="'/app/version?id='+row.id+'&appName='+row.appName">版本管理</Button>
					<Button type="info" size="small" :to="'/app/advert?id='+row.id+'&appName='+row.appName"
						style="margin-right: 5px">广告管理</Button>
					<Button type="primary" size="small" :to="'/app/funcs?id='+row.id+'&appName='+row.appName"
						style="margin-right: 5px">功能管理</Button>
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addStoreShow" :title="addForm.id?'编辑app应用':'新增app应用'">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">
				<FormItem label="app名称" prop="appName">
					<Input v-model="addForm.appName" placeholder="请输入app名称"></Input>
				</FormItem>
				<FormItem label="app编码" prop="appKey">
					<Input v-model="addForm.appKey" placeholder="请输入app编码"></Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateData">确认提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition'
	import TableFuncs from '../../components/statistics/TableFuncs'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addStoreShow: false,
				addForm: {
					appKey: '',
					appName: '',
				},
				addRule: {
					appKey: [
						{ required: true, message: '请输入市场名称', trigger: 'blur' }
					],
					appName: [
						{ required: true, message: '请输入市场编码', trigger: 'blur' },
					]
				}
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},

					{
						title: '应用名称',
						key: 'appName',
						align: 'center'
					},
					{
						title: '应用编码',
						key: 'appKey',
						align: 'center'
					},
					{
						title: '创建日期',
						key: 'createTime',
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						width: 200,
						align: 'center'
					},
					{
						title: 'app管理',
						slot: 'guanli',
						align: 'center',
						width: 400,
					},
					

				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			refreshData() {
				this.pageNum = 1,
					this.queryData = []
				this.getData()
			},
			getData() {
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize
				}
				api.statistics
					.getAppPage(queryParams)
					.then(res => {
						const result = res.data || {}
						this.totalRecord = result.totalRecordNum || 0
						this.queryData = result.records
					})
					.catch(err => {
						this.$Message.error('获取数据列表失败: ' + err.message)
					})
					.then(() => {
						this.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			addOrUpdateData() {
				const that = this
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						let params = { ...that.addForm }
						api.statistics
							.addOrEditApp(params)
							.then(res => {
								that.$Message.success('Success!');
								if (that.addForm.id) {
									//编辑
									that.queryData.forEach(item => {
										if (item.id == that.addForm.id) {
											item.appName = that.addForm.appName
											item.appKey = that.addForm.appKey
										}
									})
								} else {
									//新增
									that.refreshData()
								}
								that.addStoreShow = false
							})
							.catch(err => {
								that.$Message.error('新增失败: ' + err.message)
							})

					}
				})
			},
			addShow() {
				this.addForm = {
					appKey: '',
					appName: '',
				}
				this.addStoreShow = true
			},
			editData(rowData) {
				this.addForm = {
					id: rowData.id,
					appName: rowData.appName,
					appKey: rowData.appKey,
				}
				this.addStoreShow = true

			}
		},



	}
</script>
